import React from 'react'
import { CheckboxProps, CheckboxIconProps, Checkbox as ChakraCheckbox } from '@chakra-ui/react'
import { CheckIcon } from '../icons'

function CustomIcon(props: CheckboxIconProps) {
  const { isChecked } = props

  return isChecked ? <CheckIcon /> : null
}
function Checkbox(props: CheckboxProps) {
  return (
    <ChakraCheckbox {...props} icon={<CustomIcon />} />
  )
}

export default Checkbox